/**
 * Pokefree pick-3 bundle builder — behavior ported 1:1 from
 * louisecarter.com/bundle/pokefree (hoopsBundleStore + HoopsProductCard +
 * ProductModal):
 *
 * - Card image/title tap ALWAYS opens the product modal (gallery, option
 *   pickers, Add to Bundle). First-time adds go through the modal.
 * - Selected cards show a gold count badge, an inline −/N/+ pill (+ clones
 *   the most-recently-added variant of that product), and "Included".
 * - Bundle bar fills 3 slots; completing 3 reveals checkout CTAs.
 * - Checkout adds ONE unit of the hidden $89 bundle product with line
 *   properties "Piece 1..3" and goes straight to /checkout.
 */
(function () {
  'use strict';

  var root = document.querySelector('.lc-pokefree');
  if (!root) return;

  var MAX = parseInt(root.dataset.max, 10) || 3;
  var bundleVariant = root.dataset.bundleVariant;
  var priceLabel = (root.dataset.priceLabel || '$89').trim();
  var priceFull = (root.dataset.priceFull || priceLabel + '.00').trim();
  /* Optional label overrides (localized funnels) via a JSON block:
     <script type="application/json" data-pf-labels>{"checkout":"Zur Kasse — {price}", ...}</script> */
  var L = {
    checkout: 'Checkout — {price}',
    pick0: 'Pick {max} to continue',
    pickN: 'Pick {n} more to continue',
    bundleFull: 'Bundle is Full ({max}/{max})',
    addAnother: 'Add Another ({current}/{max})',
    addToBundle: 'Add to Bundle ({current}/{max})',
    added: '✓ Added!',
    fullToast: 'Your bundle is full — remove one to swap',
    busy: 'One moment…',
    tryAgain: 'Try again',
    optionNames: {},
    valueNames: {}
  };
  (function () {
    var el = root.querySelector('[data-pf-labels]');
    if (!el) return;
    try {
      var o = JSON.parse(el.textContent);
      for (var k in o) L[k] = o[k];
    } catch (e) {}
  })();
  function fmt(t, vars) {
    return t.replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : '{' + k + '}'; });
  }
  var picks = []; /* {pid, title, variantId, sku, optsLabel, img} */

  /* ---------- pick persistence (survive reloads / return visits) ---------- */

  var PICKS_KEY = 'lcPicks:' + root.dataset.bundleVariant;
  var PICKS_TTL = 7 * 24 * 60 * 60 * 1000;

  function savePicks() {
    try {
      if (picks.length) localStorage.setItem(PICKS_KEY, JSON.stringify({ t: Date.now(), picks: picks }));
      else localStorage.removeItem(PICKS_KEY);
    } catch (e) {}
  }

  function clearPicks() {
    try { localStorage.removeItem(PICKS_KEY); } catch (e) {}
  }

  (function restorePicks() {
    try {
      var raw = JSON.parse(localStorage.getItem(PICKS_KEY) || 'null');
      if (!raw || !raw.picks || !raw.t || Date.now() - raw.t > PICKS_TTL) return;
      raw.picks.slice(0, MAX).forEach(function (p) {
        if (p && p.pid && p.variantId) picks.push(p);
      });
    } catch (e) {}
  })();

  /* ---------- helpers ---------- */

  function cardJson(card) {
    try { return JSON.parse(card.querySelector('[data-pf-data]').textContent); }
    catch (e) { return { title: '', opts: [], variants: [], images: [] }; }
  }

  function countFor(pid) {
    return picks.filter(function (p) { return p.pid === pid; }).length;
  }

  function lastPick(pid) {
    for (var i = picks.length - 1; i >= 0; i--) if (picks[i].pid === pid) return picks[i];
    return null;
  }

  function toast(msg) {
    var t = root.querySelector('[data-pf-toast]');
    t.textContent = msg;
    t.classList.add('on');
    clearTimeout(toast._t);
    toast._t = setTimeout(function () { t.classList.remove('on'); }, 2200);
  }

  function optionLabel(name) {
    if (L.optionNames[name]) return L.optionNames[name];
    var l = name.toLowerCase();
    if (l.indexOf('color') > -1 || l.indexOf('colour') > -1) return 'Color';
    if (l.indexOf('size') > -1) return 'Size';
    if (l.indexOf('stone') > -1 || l.indexOf('birthstone') > -1) return 'Stone';
    if (l === 'style' || l === 'finish' || l === 'material') return 'Style';
    return name;
  }

  function displayValue(v) { return L.valueNames[v] || v; }

  function isColorOption(name) {
    var l = name.toLowerCase();
    return l.indexOf('color') > -1 || l.indexOf('colour') > -1 || l === 'finish' || l === 'metal color' || l === 'style' || l === 'metal' || l === 'material';
  }

  function swatchColor(v) {
    var l = v.toLowerCase();
    if (l.indexOf('rose') > -1) return '#B76E79';
    if (l.indexOf('gold') > -1) return '#D4AF37';
    if (l.indexOf('silver') > -1 || l.indexOf('steel') > -1 || l.indexOf('platinum') > -1) return '#C0C0C0';
    if (l.indexOf('crystal') > -1) return '#E8E8E8';
    if (l.indexOf('emerald') > -1 || l.indexOf('green') > -1) return '#50C878';
    if (l.indexOf('ruby') > -1 || l.indexOf('red') > -1 || l.indexOf('july') > -1) return '#E0115F';
    if (l.indexOf('diamond') > -1 || l.indexOf('white') > -1 || l.indexOf('april') > -1) return '#F5F5F5';
    if (l.indexOf('violet') > -1 || l.indexOf('purple') > -1 || l.indexOf('february') > -1) return '#9B59B6';
    if (l.indexOf('blue') > -1 || l.indexOf('september') > -1 || l.indexOf('december') > -1) return '#5DADE2';
    if (l.indexOf('pink') > -1 || l.indexOf('october') > -1) return '#FFB6C1';
    if (l.indexOf('orange') > -1 || l.indexOf('november') > -1) return '#F39C12';
    if (l.indexOf('yellow') > -1 || l.indexOf('citrine') > -1) return '#F1C40F';
    if (l.indexOf('pearl') > -1) return '#FDEBD0';
    if (l.indexOf('tiger') > -1) return '#C4893B';
    return '#D4AF37';
  }

  /* ---------- selection state -> DOM ---------- */

  /* Meta pixel: the staged cart is built through a pristine iframe fetch that
     analytics hooks can't see, so fire AddToCart explicitly per pick. */
  function metaAtc(pick) {
    try {
      if (typeof window.fbq !== 'function') return;
      var raw = String(priceFull).replace(/[^0-9.,]/g, '');
      if (raw.indexOf(',') > -1 && raw.indexOf('.') === -1) raw = raw.replace(',', '.');
      else raw = raw.replace(/,/g, '');
      var priceNum = parseFloat(raw) || 0;
      window.fbq('track', 'AddToCart', {
        content_ids: [String(pick.sku || pick.variantId)],
        content_type: 'product',
        content_name: pick.title,
        value: Math.round(priceNum / MAX * 100) / 100,
        currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'USD'
      });
    } catch (e) {}
  }

  function addPickFrom(card, variant, optsLabel, img) {
    if (picks.length >= MAX) { toast(L.fullToast); return false; }
    picks.push({
      pid: card.dataset.pid,
      title: card.dataset.title,
      variantId: variant.id,
      sku: variant.sku || '',
      optsLabel: optsLabel || '',
      img: img || variant.img || (card.querySelector('.pf-img img') || {}).src
    });
    userActed = true;
    metaAtc(picks[picks.length - 1]);
    sync();
    if (fullReady()) scheduleAutoCheckout();
    return true;
  }

  function clonePick(card) {
    var prev = lastPick(card.dataset.pid);
    if (prev) {
      if (picks.length >= MAX) { toast(L.fullToast); return; }
      picks.push(Object.assign({}, prev));
      userActed = true;
      metaAtc(prev);
      sync();
      if (fullReady()) scheduleAutoCheckout();
      return;
    }
    openModal(card, true);
  }

  function removePick(pid) {
    for (var i = picks.length - 1; i >= 0; i--) {
      if (picks[i].pid === pid) { picks.splice(i, 1); break; }
    }
    userActed = true;
    autoCkDone = false; /* editing re-arms auto-checkout for the next completion */
    sync();
  }

  function fullReady() { return picks.length === MAX; }

  /* SKU -> $0 "(Bundle)" duplicate variant id, for warehouse-friendly orders:
     each pick becomes its own $0 line (_type: item) + the paid anchor line
     (_type: box), all sharing a _bundleid — the same structure upnova emits,
     which the fulfillment ERP parses. Map lives in assets/lc-dup-map.json. */
  var dupMapPromise = null;
  function loadDupMap() {
    if (dupMapPromise) return dupMapPromise;
    var url = null;
    var scripts = document.querySelectorAll('script[src*="lc-pokefree"]');
    if (scripts.length) {
      url = scripts[scripts.length - 1].src.replace(/lc-pokefree\.js[^"']*$/, 'lc-dup-map.json');
    }
    dupMapPromise = url
      ? fetch(url).then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; })
      : Promise.resolve(null);
    return dupMapPromise;
  }

  /* ---------- progressive cart staging ----------
     Build the real Shopify cart in the background the moment the bundle
     completes, so the checkout tap is a pure redirect (upnova parity).
     Staged lines are a VALID box+items structure (cart-guard safe) and are
     torn down if the shopper edits back below MAX. */

  var userActed = false; /* no cart writes until the visitor actually does something */
  var STAGE_KEY = 'lcStaged:' + bundleVariant;
  var staged = null, stagePromise = null, stageTimer = null;
  try { staged = JSON.parse(localStorage.getItem(STAGE_KEY) || 'null'); } catch (e) {}

  function cartRoot() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }

  /* staging must be invisible: the Builder/upez cart drawer hooks window.fetch
     and auto-opens on any cart/add. Use a pristine iframe fetch it can't see. */
  var pfFrame = null;
  function cleanFetch(path, opts) {
    try {
      if (!pfFrame || !pfFrame.contentWindow) {
        pfFrame = document.createElement('iframe');
        pfFrame.style.display = 'none';
        pfFrame.setAttribute('aria-hidden', 'true');
        document.body.appendChild(pfFrame);
      }
      var w = pfFrame.contentWindow;
      if (w && w.fetch) return w.fetch(new URL(path, location.origin).href, opts);
    } catch (e) {}
    return fetch(path, opts);
  }


  function pickSig() {
    return picks.map(function (p) { return p.variantId + ':' + p.title + ':' + p.optsLabel; }).join('|');
  }

  function buildItems(dupMap) {
    var properties = {};
    picks.forEach(function (p, i) {
      properties['_Piece ' + (i + 1)] = p.title + (p.optsLabel ? ' — ' + p.optsLabel : '') + (p.sku ? ' (' + p.sku + ')' : '');
    });
    var items = [], grouped = {}, complete = !!dupMap;
    picks.forEach(function (p) {
      var dv = complete && p.sku ? dupMap[p.sku] : null;
      if (!dv) { complete = false; return; }
      grouped[dv] = (grouped[dv] || 0) + 1;
    });
    if (complete) {
      var bundleid = String(Date.now()) + String(Math.floor(Math.random() * 900) + 100);
      for (var dv in grouped) items.push({ id: dv, quantity: grouped[dv], properties: { _bundleid: bundleid, _type: 'item' } });
      properties._bundleid = bundleid;
      properties._type = 'box';
    }
    items.push({ id: bundleVariant, quantity: 1, properties: properties });
    return items;
  }

  function clearStageRecord() {
    staged = null;
    try { localStorage.removeItem(STAGE_KEY); } catch (e) {}
  }

  function unstage(keepalive) {
    var rec = staged;
    clearStageRecord();
    if (!rec || !rec.keys || !rec.keys.length) return Promise.resolve();
    var updates = {};
    rec.keys.forEach(function (k) { updates[k] = 0; });
    return cleanFetch(cartRoot() + 'cart/update.js', {
      method: 'POST', keepalive: !!keepalive,
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ updates: updates })
    }).catch(function () {});
  }

  function stageSync() {
    if (!userActed) return; /* restored bundles stage only after real interaction */
    var sig = pickSig();
    if (picks.length !== MAX) {
      if (staged) stagePromise = unstage();
      return;
    }
    if (staged && staged.sig === sig) return;
    stagePromise = (staged ? unstage() : Promise.resolve()).then(function () {
      return loadDupMap();
    }).then(function (dupMap) {
      if (picks.length !== MAX || pickSig() !== sig) return;
      return cleanFetch(cartRoot() + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: buildItems(dupMap) })
      }).then(function (r) {
        if (!r.ok) throw new Error(r.status);
        return r.json();
      }).then(function (j) {
        var keys = (j.items || []).map(function (it) { return it.key; }).filter(Boolean);
        staged = { sig: sig, keys: keys };
        try { localStorage.setItem(STAGE_KEY, JSON.stringify(staged)); } catch (e) {}
        ckBeacon('staged');
      });
    }).catch(function () { clearStageRecord(); });
  }

  function scheduleStage() {
    clearTimeout(stageTimer);
    stageTimer = setTimeout(stageSync, 400);
  }

  /* reconcile a stale stage record (cart emptied elsewhere, order completed in
     another tab) so a checkout tap never redirects to an empty checkout */
  if (staged) {
    fetch(cartRoot() + 'cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var has = (c.items || []).some(function (it) { return String(it.variant_id || it.id) === String(bundleVariant); });
      if (!has) clearStageRecord();
    }).catch(function () {});
  }


  /* checkout-click forensics: step beacons (heatmap custom events) + cart-attribute
     trace, to locate where ATC clicks die before the checkout page. */
  function ckBeacon(step, ms) {
    try {
      var u = 'https://dashboard.heatmap.com/heatmap.php?idsite=5725&rec=1&e_c=lc_ck&e_a=' + step +
        (ms != null ? '&e_v=' + Math.round(ms) : '') + '&rand=' + Date.now();
      if (navigator.sendBeacon) navigator.sendBeacon(u); else (new Image()).src = u;
    } catch (e) {}
  }

  function sync() {
    savePicks();
    var full = picks.length >= MAX;

    root.querySelectorAll('[data-pf-card]').forEach(function (card) {
      var n = countFor(card.dataset.pid);
      card.classList.toggle('selected', n > 0);
      card.classList.toggle('dimmed', full && n === 0);
      var qty = card.querySelector('[data-pf-qty]');
      if (qty) qty.hidden = n === 0;
      var nEl = card.querySelector('[data-pf-n]');
      if (nEl) nEl.textContent = n;
      var plus = card.querySelector('[data-pf-plus]');
      if (plus) plus.disabled = full;
      var inc = card.querySelector('[data-pf-included]');
      if (inc) inc.hidden = n === 0;
      var badge = card.querySelector('[data-pf-badge]');
      if (badge) badge.innerHTML = n > 1 ? '<b>' + n + '</b>' : (n === 1 ? '<b>✓</b>' : '<i class="pf-badge-plus">+</i>');
    });

    var countEl = root.querySelector('[data-pf-count]');
    if (countEl) countEl.textContent = picks.length;

    var slots = root.querySelector('[data-pf-slots]');
    if (slots) {
      var html = '';
      picks.forEach(function (p) {
        html += '<button type="button" class="pf-slot pf-slot--filled" data-pf-slot-remove data-pid="' + p.pid + '" aria-label="Remove">' +
          (p.img ? '<img src="' + p.img + '" alt="">' : '') + '<i>×</i></button>';
      });
      for (var i = picks.length; i < MAX; i++) html += '<span class="pf-slot pf-slot--empty">+</span>';
      slots.innerHTML = html;
    }

    var atc = root.querySelector('[data-pf-atc]');
    if (atc) {
      atc.disabled = !fullReady();
      atc.textContent = fullReady() ? fmt(L.checkout, {price: priceFull}) : (picks.length === 0 ? fmt(L.pick0, {max: MAX}) : fmt(L.pickN, {n: MAX - picks.length}));
      atc.classList.toggle('ready', fullReady());
    }
    var mcta = root.querySelector('[data-pf-mobilecta]');
    if (mcta) mcta.classList.toggle('on', fullReady());

    /* keep the dynamic-checkout form's line properties in sync so
       Shop Pay purchases carry the same Piece 1..3 selections */
    root.querySelectorAll('[data-pf-prop]').forEach(function (input) {
      var p = picks[parseInt(input.dataset.pfProp, 10) - 1];
      input.value = p ? p.title + (p.optsLabel ? ' — ' + p.optsLabel : '') + (p.sku ? ' (' + p.sku + ')' : '') : '';
    });

    if (full) {
      var bar = root.querySelector('[data-pf-bar]');
      if (bar && !bar.classList.contains('celebrate')) {
        bar.classList.add('celebrate');
        setTimeout(function () { bar.classList.remove('celebrate'); }, 1200);
      }
    }

    if (modalCard) syncModalCta();
    scheduleStage();
    if (UPNOVA) {
      var barU = root.querySelector('.pf-bar');
      if (barU) barU.classList.toggle('pf-bar--on', picks.length > 0);
      document.documentElement.classList.toggle('pf-has-bottombar', picks.length > 0);
    }
  }

  /* ---------- product modal ---------- */

  var modalCard = null;
  var modalData = null;
  var modalSel = {};       /* option name -> value */
  var modalImgIdx = 0;
  var modalOverrideImg = null; /* variant image not present in the gallery list */
  var justAddedTimer = null;

  function m(sel) { return root.querySelector(sel); }

  function modalVariant() {
    if (!modalData) return null;
    var names = Object.keys(modalSel);
    var match = null;
    for (var i = 0; i < modalData.variants.length; i++) {
      var v = modalData.variants[i];
      var ok = names.every(function (n) { return String(v.options[n]) === String(modalSel[n]); });
      if (ok) {
        if (v.available) return v;
        if (!match) match = v;
      }
    }
    return match || modalData.variants[0] || null;
  }

  function renderModalImages() {
    var imgs = modalData.images.length ? modalData.images : [((modalCard.querySelector('.pf-img img') || {}).src || '')];
    var stage = m('[data-pf-modal-img]');
    stage.src = modalOverrideImg || imgs[modalImgIdx] || imgs[0];
    var dots = m('[data-pf-modal-dots]');
    dots.innerHTML = imgs.length > 1 ? imgs.slice(0, 8).map(function (_, i) {
      return '<button type="button" data-pf-dot data-i="' + i + '" class="' + (i === modalImgIdx ? 'on' : '') + '"></button>';
    }).join('') : '';
    var thumbs = m('[data-pf-modal-thumbs]');
    thumbs.innerHTML = imgs.length > 1 ? imgs.slice(0, 10).map(function (src, i) {
      return '<button type="button" data-pf-thumb data-i="' + i + '" class="' + (i === modalImgIdx ? 'on' : '') + '"><img src="' + src + '" alt="" loading="lazy"></button>';
    }).join('') : '';
    var nav = imgs.length > 1 ? '' : 'none';
    m('.pf-modal-prev').style.display = nav;
    m('.pf-modal-next').style.display = nav;
  }

  function renderModalOpts() {
    var wrap = m('[data-pf-modal-opts]');
    wrap.innerHTML = modalData.opts.map(function (opt) {
      var label = optionLabel(opt.name);
      var picked = modalSel[opt.name] || '';
      var inner;
      if (isColorOption(opt.name)) {
        var vals = opt.values.slice().sort(function (a, b) {
          return (/gold/i.test(b) ? 1 : 0) - (/gold/i.test(a) ? 1 : 0);
        });
        inner = '<div class="pf-mo-swatches">' + vals.map(function (v) {
          return '<button type="button" data-pf-opt data-name="' + opt.name.replace(/"/g, '') + '" data-value="' + v.replace(/"/g, '') + '" class="pf-mo-swatch' + (picked === v ? ' active' : '') + '" title="' + displayValue(v).replace(/"/g, '') + '" style="background:' + swatchColor(v) + '"></button>';
        }).join('') + '</div>';
      } else {
        inner = '<div class="pf-mo-pills">' + opt.values.map(function (v) {
          return '<button type="button" data-pf-opt data-name="' + opt.name.replace(/"/g, '') + '" data-value="' + v.replace(/"/g, '') + '" class="pf-mo-pill' + (picked === v ? ' active' : '') + '">' + displayValue(v) + '</button>';
        }).join('') + '</div>';
      }
      return '<div class="pf-mo"><label>' + label + '<span> — ' + (picked ? displayValue(picked) : '') + '</span></label>' + inner + '</div>';
    }).join('');
    m('[data-pf-sizenote]').hidden = !modalData.opts.some(function (o) { return /size/i.test(o.name); });
  }

  function syncModalCta() {
    if (!modalCard) return;
    var n = countFor(modalCard.dataset.pid);
    var inb = m('[data-pf-inbundle]');
    inb.hidden = n === 0;
    m('[data-pf-modal-count]').textContent = n;
    var plusMini = m('[data-pf-modal-plusmini]');
    if (plusMini) plusMini.disabled = fullReady();
    var add = m('[data-pf-modal-add]');
    if (justAddedTimer) return; /* keep the green flash */
    var buyrow = m('[data-pf-buyrow]');
    if (buyrow) buyrow.hidden = !fullReady();
    if (buyrow && !buyrow.hidden) pfReturnPay();
    add.hidden = fullReady();
    add.disabled = fullReady();
    add.classList.remove('added');
    add.textContent = fullReady()
      ? fmt(L.bundleFull, {max: MAX})
      : (n > 0 ? fmt(L.addAnother, {current: picks.length, max: MAX}) : fmt(L.addToBundle, {current: picks.length, max: MAX}));
    m('[data-pf-done]').hidden = !(n > 0 && !fullReady());
  }

  function openModal(card, mini) {
    var modalEl = m('[data-pf-modal]');
    modalEl.classList.toggle('pf-modal--mini', !!mini);
    modalCard = card;
    modalData = cardJson(card);
    modalImgIdx = 0;
    modalSel = {};
    var seed = lastPick(card.dataset.pid);
    var seedVariant = null;
    if (seed) {
      for (var i = 0; i < modalData.variants.length; i++) {
        if (String(modalData.variants[i].id) === String(seed.variantId)) { seedVariant = modalData.variants[i]; break; }
      }
    }
    if (!seedVariant) {
      /* brand default: prefer Gold when a color option exists */
      var avail = modalData.variants.filter(function (v) { return v.available; });
      var gold = avail.filter(function (v) {
        var o = v.options || {};
        return Object.keys(o).some(function (n) { return isColorOption(n) && /gold/i.test(String(o[n])); });
      })[0];
      seedVariant = gold || avail[0] || modalData.variants[0];
    }
    if (seedVariant) {
      modalData.opts.forEach(function (o) { modalSel[o.name] = seedVariant.options[o.name]; });
      if (card.dataset.pfSwatchName && card.dataset.pfSwatchValue) modalSel[card.dataset.pfSwatchName] = card.dataset.pfSwatchValue;
    }
    m('[data-pf-modal-title]').textContent = modalData.title;
    var v = modalVariant();
    modalOverrideImg = null;
    if (v && v.img) {
      var idx = modalData.images.indexOf(v.img);
      if (idx > -1) modalImgIdx = idx; else modalOverrideImg = v.img;
    }
    renderModalImages();
    renderModalOpts();
    syncModalCta();
    var modal = m('[data-pf-modal]');
    modal.classList.add('on');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('pf-lock');
  }

  function closeModal() {
    var modal = m('[data-pf-modal]');
    modal.classList.remove('on');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('pf-lock');
    modalCard = null;
    modalData = null;
    if (justAddedTimer) { clearTimeout(justAddedTimer); justAddedTimer = null; }
  }

  function modalAdd() {
    if (!modalCard || fullReady()) return;
    var v = modalVariant();
    if (!v) return;
    var optsLabel = modalData.opts.map(function (o) { return modalSel[o.name]; }).filter(Boolean).join(' / ');
    var img = v.img || modalOverrideImg || modalData.images[modalImgIdx] || null;
    if (!addPickFrom(modalCard, v, optsLabel, img)) return;
    if (fullReady()) return; /* final piece: stay open, buyrow (Checkout + Shop Pay) is now showing */
    var add = m('[data-pf-modal-add]');
    add.textContent = L.added;
    add.classList.add('added');
    if (justAddedTimer) clearTimeout(justAddedTimer);
    justAddedTimer = setTimeout(function () {
      justAddedTimer = null;
      closeModal(); /* back to the grid, like upnova */
    }, 750);
  }

  /* ---------- events ---------- */

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-pf-modal-close]')) { closeModal(); return; }

    var dot = e.target.closest('[data-pf-dot], [data-pf-thumb]');
    if (dot && modalData) { modalOverrideImg = null; modalImgIdx = parseInt(dot.dataset.i, 10); renderModalImages(); return; }

    if (e.target.closest('[data-pf-img-prev]') && modalData) {
      var imgCount = Math.max(1, modalData.images.length);
      modalOverrideImg = null; modalImgIdx = (modalImgIdx - 1 + imgCount) % imgCount; renderModalImages(); return;
    }
    if (e.target.closest('[data-pf-img-next]') && modalData) {
      var imgCount2 = Math.max(1, modalData.images.length);
      modalOverrideImg = null; modalImgIdx = (modalImgIdx + 1) % imgCount2; renderModalImages(); return;
    }

    var opt = e.target.closest('[data-pf-opt]');
    if (opt && modalData) {
      modalSel[opt.dataset.name] = opt.dataset.value;
      var v = modalVariant();
      modalOverrideImg = null;
      if (v && v.img) {
        var idx = modalData.images.indexOf(v.img);
        if (idx > -1) modalImgIdx = idx; else modalOverrideImg = v.img;
      } else {
        /* variant has no linked image: show the product's hero image */
        modalImgIdx = 0;
      }
      renderModalImages();
      renderModalOpts();
      syncModalCta();
      return;
    }

    if (e.target.closest('.pf-payform')) { if (staged) unstage(true); }
    if (e.target.closest('[data-pf-modal-add]')) { modalAdd(); return; }
    if (e.target.closest('[data-pf-modal-plusmini]')) { if (modalCard) clonePick(modalCard); syncModalCta(); return; }
    if (e.target.closest('[data-pf-modal-minus]')) { if (modalCard) removePick(modalCard.dataset.pid); return; }

    var sw = e.target.closest('[data-pf-cswatch]');
    if (sw) {
      var cardS = sw.closest('[data-pf-card]');
      cardS.querySelectorAll('[data-pf-cswatch]').forEach(function (b) { b.classList.toggle('active', b === sw); });
      cardS.dataset.pfSwatchName = sw.dataset.name;
      cardS.dataset.pfSwatchValue = sw.dataset.value;
      var dataS = cardJson(cardS);
      var matchS = dataS.variants.filter(function (v) { return v.available && String((v.options || {})[sw.dataset.name]) === String(sw.dataset.value); })[0]
        || dataS.variants.filter(function (v) { return String((v.options || {})[sw.dataset.name]) === String(sw.dataset.value); })[0];
      if (matchS) {
        cardS.dataset.pfSwatchVid = matchS.id;
        var imgS = cardS.querySelector('.pf-img img');
        if (imgS && (matchS.img || (dataS.images || [])[0])) imgS.src = matchS.img || dataS.images[0];
      }
      return;
    }

    var addBtn = e.target.closest('[data-pf-add-direct]');
    if (addBtn) {
      var cardA = addBtn.closest('[data-pf-card]');
      if (cardA.classList.contains('dimmed')) return;
      var flashAdd = function () {
        var orig = addBtn.textContent;
        addBtn.textContent = '✓';
        addBtn.classList.add('added');
        setTimeout(function () { addBtn.textContent = orig; addBtn.classList.remove('added'); }, 900);
      };
      var dataA = cardJson(cardA);
      var needsChoice = (dataA.opts || []).some(function (o) { return (o.values || []).length > 1; });
      if (needsChoice) { openModal(cardA, true); return; }
      if (lastPick(cardA.dataset.pid)) { clonePick(cardA); flashAdd(); return; }
      var vA = dataA.variants.filter(function (v) { return v.available; })[0] || dataA.variants[0];
      if (!vA) { openModal(cardA, true); return; }
      var lblA = Object.keys(vA.options || {}).map(function (k) { return vA.options[k]; }).filter(Boolean).join(' / ');
      if (addPickFrom(cardA, vA, lblA, vA.img || null)) flashAdd();
      return;
    }

    var plus = e.target.closest('[data-pf-plus]');
    if (plus) { clonePick(plus.closest('[data-pf-card]')); return; }

    var minus = e.target.closest('[data-pf-minus]');
    if (minus) { removePick(minus.closest('[data-pf-card]').dataset.pid); return; }

    var slotRemove = e.target.closest('[data-pf-slot-remove]');
    if (slotRemove) { removePick(slotRemove.dataset.pid); return; }

    var cimg = e.target.closest('[data-pf-cimg]');
    if (cimg) {
      e.preventDefault();
      e.stopPropagation();
      var cardI = cimg.closest('[data-pf-card]');
      var dataI = cardJson(cardI);
      var imgsI = dataI.images || [];
      if (imgsI.length > 1) {
        var idx = (parseInt(cardI.dataset.pfImgIdx || '0', 10) + parseInt(cimg.dataset.pfCimg, 10) + imgsI.length) % imgsI.length;
        cardI.dataset.pfImgIdx = idx;
        var imEl = cardI.querySelector('.pf-img img');
        if (imEl) imEl.src = imgsI[idx];
      }
      return;
    }
    var open = e.target.closest('[data-pf-open]');
    if (open) {
      var card = open.closest('[data-pf-card]');
      if (card.classList.contains('dimmed')) return; /* full + unselected = disabled, like the original */
      openModal(card);
      return;
    }

    var tab = e.target.closest('[data-pf-tab]');
    if (tab) {
      root.querySelectorAll('[data-pf-tab]').forEach(function (t) { t.classList.toggle('active', t === tab); });
      var cat = tab.dataset.pfTab;
      root.querySelectorAll('[data-pf-card]').forEach(function (card) {
        card.hidden = cat !== 'All' && card.dataset.category !== cat;
      });
      return;
    }

    var scroll = e.target.closest('[data-pf-scroll-grid]');
    if (scroll) {
      var grid = root.querySelector('.pf-grid');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var prev = e.target.closest('[data-pf-rev-prev]');
    var next = e.target.closest('[data-pf-rev-next]');
    if (prev || next) {
      var track = root.querySelector('[data-pf-rev-track]');
      var cardEl = track.firstElementChild;
      var step = cardEl ? cardEl.getBoundingClientRect().width + 16 : 300;
      track.scrollBy({ left: (next ? 1 : -1) * step * (window.innerWidth >= 720 ? 3 : 1), behavior: 'smooth' });
      return;
    }

    var atc = e.target.closest('[data-pf-atc], [data-pf-atc2]');
    if (atc && fullReady()) { startCheckout(atc); return; }
  });

  function startCheckout(atc) {
      if (!fullReady()) return;
      var ckT0 = Date.now();
      ckBeacon('click');
      var ckHide = function () { ckBeacon('leave', Date.now() - ckT0); };
      window.addEventListener('pagehide', ckHide, { once: true });
      atc.disabled = true;
      atc.textContent = L.busy;
      /* instant response: full-screen transition cover so the tap never feels dead */
      var cover = root.querySelector('[data-pf-cover]');
      if (!cover) {
        cover = document.createElement('div');
        cover.className = 'pf-cover';
        cover.setAttribute('data-pf-cover', '');
        cover.innerHTML = '<div class="pf-cover-inner"><span class="pf-cover-spin"></span><b>' + (L.coverTitle || 'Securing your bundle…') + '</b><span>' + (L.coverSub || 'Taking you to checkout') + '</span></div>';
        root.appendChild(cover);
      }
      cover.classList.add('on');
      var sigNow = pickSig();
      Promise.resolve(stagePromise).catch(function () {}).then(function () {
        /* cart already staged for exactly these picks -> pure redirect */
        if (staged && staged.sig === sigNow) { ckBeacon('staged_hit', Date.now() - ckT0); return null; }
        return loadDupMap().then(function (dupMap) {
          ckBeacon('map', Date.now() - ckT0);
          return fetch(cartRoot() + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: buildItems(dupMap) })
          });
        });
      }).then(function (r) {
        if (r && !r.ok) { ckBeacon('add_fail', Date.now() - ckT0); throw new Error(r.status); }
        if (r) ckBeacon('add_ok', Date.now() - ckT0);
        var routeRoot = cartRoot();
        /* stamp the cart so the order / abandoned checkout carries the click trace */
        try {
          fetch(routeRoot + 'cart/update.js', { method: 'POST', keepalive: true,
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ attributes: { _lc_ck: 'ok+' + (Date.now() - ckT0) + 'ms', _lc_nav_epoch: String(Math.round(Date.now() / 1000)) } }) }).catch(function () {});
        } catch (e2) {}
        /* smoking gun: if we are still visible 3s after issuing the redirect, navigation failed */
        setTimeout(function () {
          if (!document.hidden) {
            ckBeacon('stuck3s', Date.now() - ckT0);
            /* Shopify-readable marker: if this visitor later gets through, their
               order/abandoned checkout carries proof they were stuck once */
            try {
              fetch(routeRoot + 'cart/update.js', { method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ attributes: { _lc_stuck: String(Date.now() - ckT0) + 'ms ' + (navigator.userAgent || '').slice(0, 80) } }) }).catch(function () {});
            } catch (e3) {}
          }
        }, 3000);
        if (root.dataset.pfFlow === 'cart') {
          /* upnova-style: bundle now lives in the real cart; let the cart
             drawer present it (it auto-opens on cart/add). Reset the builder
             so a second click can't double-add. */
          clearPicks();
          picks.length = 0;
          sync();
          atc.disabled = false;
          setTimeout(function () {
            var drawer = document.querySelector('.upez--inner-drawer-container');
            var visible = drawer && drawer.offsetParent !== null && drawer.getBoundingClientRect().width > 0;
            if (!visible) window.location.href = routeRoot + 'cart';
          }, 1200);
        } else {
          clearPicks();
          clearStageRecord();
          ckBeacon('nav', Date.now() - ckT0);
          window.location.href = routeRoot + 'checkout';
        }
      }).catch(function () {
        var cv = root.querySelector('[data-pf-cover]');
        if (cv) cv.classList.remove('on');
        atc.disabled = false;
        atc.textContent = L.tryAgain;
      });
  }


  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeModal();
  });

  /* Shop Pay wallet buttons refuse to render inside the display:none modal.
     Prime the payform offscreen (rendered, invisible) at load; return it to the
     buyrow the first time the bundle completes. */
  var pfReturnPay = function () {};
  (function () {
    var pay = root.querySelector('.pf-payform');
    if (!pay) return;
    var slot = document.createElement('div');
    pay.parentNode.insertBefore(slot, pay);
    var prime = document.createElement('div');
    prime.style.cssText = 'position:fixed;left:-9999px;bottom:0;width:340px;overflow:hidden;';
    prime.setAttribute('aria-hidden', 'true');
    document.body.appendChild(prime);
    prime.appendChild(pay);
    var done = false;
    pfReturnPay = function () {
      if (done) return;
      done = true;
      slot.parentNode.replaceChild(pay, slot);
      prime.remove();
    };
  })();

  /* upnova parity: the moment the 7th piece lands, carry the shopper straight
     into checkout (staged cart makes this a ~0.3s redirect). Upnova-mode only. */
  var autoCkDone = false;
  window.addEventListener('pageshow', function (ev) {
    /* back from checkout restores this page from bfcache with the once-guard
       still set; re-arm, and re-offer checkout to a still-full bundle */
    if (ev.persisted) {
      autoCkDone = false; /* back from checkout: never re-hijack; a fresh completion may re-fire */
    }
  });
  function scheduleAutoCheckout(delay) {
    if (!UPNOVA || autoCkDone || !fullReady()) return;
    autoCkDone = true;
    setTimeout(function () {
      if (!fullReady()) { autoCkDone = false; return; }
      closeModal();
      startCheckout(root.querySelector('[data-pf-atc]') || root.querySelector('[data-pf-atc2]') || { disabled: false, textContent: '' });
    }, delay || 400);
  }

  /* ---------- upnova-style mode (bottom bar, card swatches, upnova order) ---------- */
  var UPNOVA = root.dataset.pfUpnova === '1';
  function normTitle(t) {
    return String(t || '').toLowerCase().replace(/\s*\(bundle\)\s*/g, '').replace(/[^a-z0-9]+/g, '');
  }
  if (UPNOVA) (function () {
    var upnovaRank = null;
    var grid = root.querySelector('.pf-grid');
    var sorting = false;
    function sortGrid() {
      if (!upnovaRank || !grid || sorting) return;
      sorting = true;
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-pf-card]'));
      var sorted = cards.map(function (c, i) {
        var r = upnovaRank[normTitle(c.dataset.title)];
        return { c: c, r: r != null ? r : 9000 + i };
      }).sort(function (a, b) { return a.r - b.r; }).map(function (x) { return x.c; });
      var same = cards.every(function (c, i) { return c === sorted[i]; });
      if (!same) sorted.forEach(function (c) { grid.appendChild(c); });
      sorting = false;
    }
    var url = null, scripts = document.querySelectorAll('script[src*="lc-pokefree"]');
    if (scripts.length) url = scripts[scripts.length - 1].src.replace(/lc-pokefree\.js[^"']*$/, 'lc-upnova-order.json');
    if (url) fetch(url).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j) return;
      upnovaRank = {};
      j.forEach(function (t, i) { upnovaRank[t] = i; });
      sortGrid();
    }).catch(function () {});

    function decorate(card) {
      if (card.dataset.pfSw) return;
      card.dataset.pfSw = '1';
      var data = cardJson(card);
      var opt = (data.opts || []).filter(function (o) {
        if (!isColorOption(o.name)) return false;
        var vs = o.values || [];
        if (vs.length < 2 || vs.length > 8) return false;
        /* only real color choices: values must map to at least 2 distinct swatch
           colors (letter/size-style lists all collapse to the default gold) */
        var uniq = {};
        vs.forEach(function (v) { uniq[swatchColor(v)] = 1; });
        return Object.keys(uniq).length >= 2;
      })[0];
      var row = document.createElement('div');
      row.className = 'pf-cswatches';
      if (!opt) {
        /* ghost row keeps card heights even so ADD buttons align */
        row.className += ' pf-cswatches--ghost';
        row.innerHTML = '<span class="pf-cswatch" style="visibility:hidden"></span>';
        var infoG = card.querySelector('.pf-info--cta') || card.querySelector('.pf-info');
        var btnG = card.querySelector('.pf-add-btn');
        if (infoG && btnG) infoG.insertBefore(row, btnG);
        else if (infoG) infoG.appendChild(row);
        return;
      }
      var vals = opt.values.slice().sort(function (a, b) { return (/gold/i.test(b) ? 1 : 0) - (/gold/i.test(a) ? 1 : 0); }).slice(0, 6);
      row.innerHTML = vals.map(function (v) {
        var esc = v.replace(/"/g, '');
        return '<button type="button" class="pf-cswatch" data-pf-cswatch data-name="' + opt.name.replace(/"/g, '') + '" data-value="' + esc + '" title="' + esc + '" style="background:' + swatchColor(v) + '"></button>';
      }).join('');
      var info = card.querySelector('.pf-info--cta') || card.querySelector('.pf-info');
      var btn = card.querySelector('.pf-add-btn');
      if (info && btn) info.insertBefore(row, btn);
      else if (info) info.appendChild(row);
      /* card image arrows: click through this product's photos on the grid */
      var imgWrap = card.querySelector('.pf-img');
      if (imgWrap && (data.images || []).length > 1 && !imgWrap.querySelector('.pf-carr')) {
        var prev = document.createElement('span');
        prev.className = 'pf-carr pf-carr--prev';
        prev.setAttribute('data-pf-cimg', '-1');
        prev.innerHTML = '&#8249;';
        var next = document.createElement('span');
        next.className = 'pf-carr pf-carr--next';
        next.setAttribute('data-pf-cimg', '1');
        next.innerHTML = '&#8250;';
        imgWrap.appendChild(prev);
        imgWrap.appendChild(next);
      }
    }
    function decorateAll() { root.querySelectorAll('[data-pf-card]').forEach(decorate); }
    decorateAll();
    if (grid) new MutationObserver(function () { if (!sorting) { decorateAll(); sortGrid(); } }).observe(grid, { childList: true });
  })();

  /* the Builder/upez cart drawer polls cart state and auto-opens on ANY cart
     change — including background staging. Funnels never use the drawer
     (checkout is direct), so keep it and its backdrop suppressed here. */
  (function killDrawer() {
    function sweep() {
      document.querySelectorAll('.upez--inner-drawer-container').forEach(function (el) {
        var b = el.closest('.builder-block') || el;
        b.style.display = 'none';
      });
      document.querySelectorAll('.builder-block').forEach(function (el) {
        var cs = getComputedStyle(el);
        if (cs.position === 'fixed' && parseInt(cs.zIndex || '0', 10) > 99998 && cs.display !== 'none') {
          var r = el.getBoundingClientRect();
          if (r.width >= window.innerWidth * 0.7 && r.height >= window.innerHeight * 0.6) el.style.display = 'none';
        }
      });
    }
    sweep();
    try { new MutationObserver(sweep).observe(document.body, { childList: true }); } catch (e) {}
    setInterval(sweep, 800);
  })();

  /* un-break position:sticky: theme section wrappers ship overflow:hidden */
  (function () {
    var sec = root.closest('.shopify-section');
    if (sec) sec.style.overflow = 'visible';
  })();

  /* pin the bundle bar just below the theme's sticky header (height varies) */
  (function () {
    var bar = root.querySelector('.pf-bar');
    if (!bar) return;
    if (UPNOVA) {
      bar.classList.add('pf-bar--bottom');
      return; /* visibility + body padding toggled per-pick in sync() */
    }
    var cands = Array.prototype.slice.call(document.querySelectorAll('header, .header, .site-header, [id^="shopify-section-"][id*="header"]'));
    var sticky = cands.filter(function (el) {
      var cs = getComputedStyle(el);
      return cs.position === 'sticky' || cs.position === 'fixed';
    });
    function upd() {
      var t = 0;
      sticky.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top <= 1 && r.bottom > t && r.height > 0 && r.height < 320) t = r.bottom;
      });
      bar.style.top = Math.max(0, Math.round(t)) + 'px';
    }
    window.addEventListener('scroll', function () { requestAnimationFrame(upd); }, { passive: true });
    window.addEventListener('resize', upd);
    upd(); setTimeout(upd, 1500);
  })();

  sync();
  /* late re-syncs: the client-built grid (lc-bundle-de.js) may render cards
     after restore, so badge/dim state needs a second pass */
  if (picks.length) { setTimeout(sync, 1500); setTimeout(sync, 4000); }

  /* warm the SKU->dup map so the checkout click doesn't pay a fetch */
  setTimeout(loadDupMap, 2000);
})();
